/*
 * Defer the newsletter popup while a drawer is open.
 *
 * Klaviyo's popup fires on a timer (about ten seconds after the page loads)
 * whatever the visitor is doing. On a phone that landed mid-postcode in the
 * cart drawer: the popup is aria-modal and takes focus, Zapiet validates the
 * postcode the moment the field loses focus, and a fragment like "SO14" was
 * approved while the remaining keystrokes went into the popup.
 *
 * Two parts, and both are needed:
 *  1. styles-component-drawer.css keeps the popup invisible and inert while
 *     any drawer is open (html.overlay-on), which is what stops the focus
 *     steal in the first place.
 *  2. This script closes the invisible popup straight away and re-opens it
 *     once the drawer closes. Without the close, Klaviyo counts the next tap
 *     anywhere as "clicked outside" and dismisses the form for good; without
 *     the re-open, that visitor never sees it. klaviyo.openForm() is Klaviyo's
 *     public API and ignores the form's own trigger rules.
 *
 * Klaviyo announces its forms with a "klaviyoForms" event on window (types:
 * open, close, viewedStep, submit). The open event fires just before the
 * dialog is in the DOM, hence the short poll for its Close button.
 * (id: b22-defer-popup)
 */
(function () {
  var deferredFormId = null;

  function drawerOpen() {
    return document.documentElement.classList.contains('overlay-on');
  }

  function closeControl() {
    var dialog = document.querySelector('[aria-label="POPUP Form"]');
    return dialog && dialog.querySelector('button[aria-label*="lose" i], [role="button"][aria-label*="lose" i]');
  }

  function closeWhenRendered(tries) {
    var button = closeControl();
    if (button) {
      button.click();
      return;
    }
    if (tries > 0) setTimeout(function () { closeWhenRendered(tries - 1); }, 100);
  }

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail || {};
    if (detail.type !== 'open' || !drawerOpen()) return;
    if (detail.formId) deferredFormId = detail.formId;
    closeWhenRendered(20);
  });

  function reopenWhenDrawerCloses() {
    new MutationObserver(function () {
      if (!deferredFormId || drawerOpen()) return;
      var id = deferredFormId;
      deferredFormId = null;
      // Give the drawer's closing transition a moment before the form appears.
      setTimeout(function () {
        if (window.klaviyo && typeof window.klaviyo.openForm === 'function') window.klaviyo.openForm(id);
      }, 800);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenWhenDrawerCloses);
  } else {
    reopenWhenDrawerCloses();
  }
})();
